import { faGift } from "@fortawesome/duotone-light-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { JoonUIColor, Typography } from "@joonapp/web-shared"
import { useEffect } from "react"
import { useTranslation } from "react-i18next"

import { useReferralGiftCardStore } from "./ReferralGiftCardSection"
import { useReferralModalStore } from "./ReferralModal"
import { localStorageItems } from "../../../util/storage"

const ReferralGiftButton = () => {
  const { t } = useTranslation()
  const { showTooltip, setShowTooltip } = useReferralGiftCardStore()
  const { onOpen: onOpenReferralModal } = useReferralModalStore()
  const showReferralGiftButton =
    (localStorage.getItem(localStorageItems.hasSeenReferralFTUXModal) &&
      localStorage.getItem(
        localStorageItems.hasDismissedReferralGiftCardSection
      )) ||
    showTooltip

  useEffect(() => {
    if (showReferralGiftButton) {
      setTimeout(() => {
        setShowTooltip(false)
      }, 3000)
    }
  }, [setShowTooltip, showReferralGiftButton])

  return (
    <>
      <button
        className={`flex items-center justify-center w-[32px] h-[32px] rounded-full bg-yellow-300! transition-opacity duration-300 ${showReferralGiftButton ? "opacity-100" : "opacity-0"}`}
        onClick={() => onOpenReferralModal("me_tab_icon")}
      >
        <FontAwesomeIcon
          icon={faGift}
          color={JoonUIColor.icon.accent}
          fontSize={16}
        />
      </button>
      <div
        className={`absolute top-full right-0 bg-neutral-700 text-white p-2 rounded-lg max-w-[280px] shadow pointer-events-none transition-opacity duration-300 ${showTooltip ? "opacity-100" : "opacity-0"}`}
      >
        <Typography
          variant="bodySmall"
          color={JoonUIColor.text.inverted}
          className="line-clamp-2"
        >
          {t("ME_REFERRAL_TOOLTIP")}
        </Typography>
      </div>
    </>
  )
}

export default ReferralGiftButton
